import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TawkToChat = () => {
  const { language } = useLanguage();
  const location = useLocation();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Don't load on admin page (/lina)
    if (location.pathname.startsWith('/lina')) {
      // Remove existing Tawk widget if navigating to admin
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
      return;
    }

    // Only show chat in English
    if (language !== 'en') {
      // Hide widget if language changed from English
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
      return;
    }

    // Don't load twice
    if (loaded) {
      // Show widget if already loaded and conditions are met
      if (window.Tawk_API && window.Tawk_API.showWidget) {
        window.Tawk_API.showWidget();
      }
      return;
    }
    
    if (document.querySelector('script[src*="tawk.to"]')) {
      // Script already exists, just show widget
      if (window.Tawk_API && window.Tawk_API.showWidget) {
        window.Tawk_API.showWidget();
      }
      setLoaded(true);
      return;
    }

    // Fetch settings and load
    fetch(`${BACKEND_URL}/api/chat-settings`)
      .then(res => res.json())
      .then(settings => {
        if (!settings?.enabled || !settings.tawk_property_id) {
          return;
        }

        // Use English widget only
        const widgetId = settings.tawk_widget_id_en;
        
        if (!widgetId) {
          return;
        }
        
        // Standard Tawk.to embed
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_LoadStart = new Date();

        const s1 = document.createElement('script');
        s1.async = true;
        s1.src = `https://embed.tawk.to/${settings.tawk_property_id}/${widgetId}`;
        s1.charset = 'UTF-8';
        
        const s0 = document.getElementsByTagName('script')[0];
        s0.parentNode.insertBefore(s1, s0);
        
        setLoaded(true);
      })
      .catch(err => console.error('[TawkTo] Error:', err));
  }, [loaded, language, location.pathname]);

  return null;
};

export default TawkToChat;
